package pl.nickers.match3.ecs

import pl.nickers.match3.SoundEvent

/**
 * RESOLVE.BOMB subphase: converts every [FusedBombComponent] into an [ExplodingComponent]
 * so that [EffectResolveSystem] processes the blast in the subsequent RESOLVE.EFFECT subphase.
 */
internal class BombFuseSystem : BaseSystem() {
    private lateinit var fusedBombMapper: ComponentMapper<FusedBombComponent>
    private lateinit var explodingMapper: ComponentMapper<ExplodingComponent>

    override fun initialize() {
        fusedBombMapper = world.mapper()
        explodingMapper = world.mapper()
    }

    override fun processSystem() {
        val board = world.boardState() ?: return
        if (board.phase != GamePhase.RESOLVE || board.currentSubphase != ResolveSubphase.BOMB) return
        val fused = world.getEntitiesForAspect(Aspect.all(FusedBombComponent::class)).toList()
        if (fused.isEmpty()) return
        for (entity in fused) {
            fusedBombMapper.remove(entity)
            explodingMapper.set(entity, ExplodingComponent())
        }
        world.enqueueAudioEvent(SoundEvent.BOMB_EXPLODE)
        board.didWork = true
    }
}
